export const HOST_URL = process.env.REACT_APP_API_URL || 'https://localhost:44378/';
const VERSION = "v1.0";
export const config = {
  ROOT_URL: `${HOST_URL}api/${VERSION}/`,
  REST_API: {
    ExceptionLogger: {
      LogError: `ExceptionLogger/LogError`,
    },
    Account: {
      LogIn: "Account/Login",
      GoogleAuth: "Account/GoogleAuth",
      FacebookAuth: "Account/FacebookAuth",
      RegisterByAdmins: "Account/RegisterByAdmins",
      RegisterByCompanyAdmin: "Account/RegisterByCompanyAdmin",
      Register: "Account/Register",
      LogOff: "Account/Logout",
      RefreshToken: "Account/RefreshToken",
      GetAdminRoles: "Account/GetAdminRoles",
      GetSuperAdminRoles: "Account/GetSuperAdminRoles",
      onGetApprovers: "Account/GetCompanyApprovers",
      UpdateUserAnnualLeaveFlag: "Account/UpdateUserAnnualLeaveFlag",
      UpdateAnyProfileImage: "Account/UpdateAnyProfileImage",
      DeactivateAccount: "Account/DeactivateAccount",
      DeleteCompanyAccount: "Account/DeleteCompanyAccount",
      ForgotPassword: "Account/ForgotPassword",
      GetUserDetails: "Account/GetUserDetails",
      ContactUs: "Account/ContactUs",
      ChangePassword: "Account/ChangePassword",
      UpdatePrimaryLanguage: "Account/UpdatePrimaryLanguage",
    },
    Statistics: {
      DashboardSummary: "Statistics/DashboardSummary",
      ManagerDashboardSummary: "Statistics/ManagerDashboardSummary",
      UserDashboardSummary: "Statistics/UserDashboardSummary",
      OnLeaveGrid: "Statistics/OnLeaveGrid",
      LeaveStatistics: "Statistics/LeaveStatistics",
    },
    AppUser: {
      GetUsers: "AppUser/GetUsers",
      GetUser: "AppUser/GetUser",
      EditUser: "AppUser/EditUser",
      ToggleUserStatus: "AppUser/ToggleUserStatus",
      Search: "AppUser/Search",
      BulkUploadTemplate: "AppUser/BulkUploadTemplate",
      BulkUpload: "AppUser/BulkUploadUsers",
      Delete: "AppUser/DeleteUser",
      ExportUsers: "AppUser/ExportUsers",
      ExportUsersCsv: "AppUser/ExportUsersCsv",
      ExportUsersPdf: "AppUser/ExportUsersPdf",
    },
    Company: {
      Get: `Company/`,
      Create: `Company`,
      UpdateCompanyLogo: `Company/UpdateCompanyLogo`,
      GetSettings: `Company/GetSettings`,
      UpdateSettings: `Company/UpdateSettings`,
    },
    CompanyAutoLeaveSettings: {
      ByCompany: `CompanyAutoLeaveSettings/ByCompany`,
      Save: `CompanyAutoLeaveSettings/Save`,
    },
    Office: {
      GetCompanyOffices: `Office/GetCompanyOffices`,
      CurrentUserAssociatedWithWorkPlace: `Office/CurrentUserAssociatedWithWorkPlace`,
      Add: `Office`,
      Edit: `Office`,
      Delete: `Office`,
      GetOfficeByCompany: `Office/GetOfficeByCompany`,
      State: 'Office/GetCountryStates',
      BusinessDaysPresets: 'Office/GetBusinessDaysPresets',
      GetOfficeBusinessDays: 'Office/GetOfficeBusinessDays'
    },
    Employee: {
      Create: `Employee/PersonalInfo`,
      EmployeeDetail: `Employee/EmployeeDetailInfo`,
      OtherInfo: `Employee/OtherInfo`,
      ContactInfo: `Employee/ContactInfo`,
      EducationInfo: `EmployeeEducation/PostRange`,
      EmployeeFamily: `EmployeeFamily/PostRange`,
      EmployeeSkill: `EmployeeSkill/PostRange`,
      EmployeeWorkHistory: `EmployeeWorkHistory/PostRange`,
      GetEmployees: `Employee/GetEmployees`,
      GetSingleEmployee: `Employee/`,
      SearchEmployees: `Employee/Search?query=`,
      Delete: `Employee/Delete`,
      SaveImage: `Employee/SaveEmployeeImage`,
    },
    SalaryHistory: {
      Update: `Employee/PersonalInfo`,
      GetSalaryHistory: `SalaryHistory/GetSalaries`,
      GetSalaryHistoryByEmployeeId: `SalaryHistory/GetByEmployeeId?employeeId=`,
      GetLatestByEmployeeId: `SalaryHistory/GetLatestByEmployeeId?employeeId=`,
      SalaryInfo: `SalaryHistory/SalaryInfo`,
    },
    EmployeeEducation: {
      Delete: `EmployeeEducation/Delete`,
    },
    EmployeeWorkHistory: {
      Delete: `EmployeeWorkHistory/Delete`,
    },
    EmployeeFamily: {
      Delete: `EmployeeFamily/Delete`,
    },
    EmployeeSkill: {
      Delete: `EmployeeSkill/Delete`,
    },
    Department: {
      Create: `Department`,
      Get: `Department/`,
      Update: `Department`,
      Delete: `Department/SoftDelete?id=`,
      UserDepartments: "Department/UserDepartments",
      GetDepartmentsWithUsersByOffice: "Department/GetDepartmentsWithUsersByOffice",
    },
    EmploymentType: {
      Create: `EmploymentType/create`,
      Get: `EmploymentType/`,
      Patch: `EmploymentType/patch`,
      Delete: `EmploymentType/SoftDelete?id=`,
    },
    Designation: {
      Create: `Designation/create`,
      Get: `Designation/`,
      Patch: `Designation/patch`,
      Delete: `Designation/SoftDelete?id=`,
    },
    Project: {
      CreateProject: `Project/CreateProject`,
      Get: `Project/`,
      UpdateProject: `Project/UpdateProject/`,
      Delete: `Project/SoftDelete?id=`,
    },
    Team: {
      Create: `Team/create`,
      Get: `Team/`,
      Patch: `Team/patch`,
      Delete: `Team/SoftDelete?id=`,
      UserTeams: `Team/UserTeams/`,
    },
    /** Projects assigned to the user for timesheet entry (TeamProjectController) */
    TeamProject: {
      TimesheetProjects: `TeamProject/timesheetProjects`,
    },
    /** Current user's timesheets (UserTimeSheetController) */
    UserTimeSheet: {
      Weekly: `UserTimeSheet/weekly`,
      OffDays: `UserTimeSheet/off-days`,
      GetTimeLog: `UserTimeSheet/getTimeLog`,
      ExportTimeLog: `UserTimeSheet/ExportTimeLog`,
      TimesheetDetail: `UserTimeSheet/timesheet-detail`,
      LogTimeSheet: `UserTimeSheet/LogTimeSheet`,
      SubmitTimeSheet: `UserTimeSheet/SubmitTimeSheet`,
      UpdateTimeSheetStatus: `UserTimeSheet/UpdateTimeSheetStatus`,
      ApprovalVelocity: `UserTimeSheet/ApprovalVelocity`,
      TimeSheetsStats: `UserTimeSheet/TimeSheetsStats`,
      GetEmployeePerformanceMatrixExport: `UserTimeSheet/GetEmployeePerformanceMatrixExport`,
      GetEmployeePerformanceMatrixPdf: `UserTimeSheet/GetEmployeePerformanceMatrixPdf`,
      EmployeePerformanceList: `UserTimeSheet/EmployeePerformanceList`,
    },
    /** Approver queue (UserTimeSheetApprovalController) */
    UserTimeSheetApproval: {
      Summary: `UserTimeSheetApproval/Summary`,
      Queue: `UserTimeSheetApproval/Queue`,
      ExportExcel: `UserTimeSheetApproval/ExportExcel`,
      ExportCsv: `UserTimeSheetApproval/ExportCsv`,
      ExportPdf: `UserTimeSheetApproval/ExportPdf`,
      Decision: `UserTimeSheetApproval/Decision`,
      Detail: `UserTimeSheetApproval/Detail`,
      Pdf: `UserTimeSheetApproval/Pdf`,
    },
    Skill: {
      Create: `Skill`,
      Get: `Skill/`,
      Delete: `Skill/Delete?id=`,
      GetByDepId: `Skill/DepartmentSkills`,
    },
    ImportExport: {
      DownloadTemplate: `ImportExport/EmployeeTemplate`,
      UploadFile: `ImportExport/UploadCsv`,
    },
    TimeOff: {
      GetEmpYearLeaves: `Leave/GetEmpYearLeaves?userId=`,
      GetEmployeeCalendar: `Leave/GetEmployeeCalendar`,
      BookEmployeeTimeOff: `Leave/Post`,
      UpdateLeave: `Leave/Update`,
      GetLeaveTypes: `LeaveType/GetUserLeaveTypes?userId=`,
      ValidateLeaveAvailability: `Leave/ValidateLeaveAvailability`,
      GetLeaveByGroupId: `Leave/GetLeavesByGroup?groupId=`,
      PostBulkGroupLeaves: `Leave/PostBulkGroupLeaves`,
      GetSelfRequestedLeavesStats: `Leave/GetSelfRequestedLeavesStats`,
      GetSelfRequestedLeaves: `Leave/GetSelfRequestedLeaves`,
    },
    UserFavorites: {
      UpsertFavorite: `UserFavorites/UpsertFavorite`,
    },
    LeaveType: {
      GetLeaveTypesOfCompany: `LeaveType/`,
      GetActiveLeaveTypes: `LeaveType/GetActiveLeaveTypes`,
      CreateLeaveType: `LeaveType`,
      SoftRemove: `LeaveType/SoftRemove?id=`,
      UpdateLeaveType: `LeaveType`,
      GetCompanyAnnualLeaveTypeId: "LeaveType/GetCompanyAnnualLeaveTypeId"
    },
    LeaveAccrual: {
      CreateTier: `LeaveAccrual/tiers`,
      UpdateTier: `LeaveAccrual/tiers/`,
      DeleteTier: `LeaveAccrual/tiers/`,
      GetTiers: `LeaveAccrual/tiers/`,
      SaveAccrualSettings: `LeaveAccrual/settings`,
      GetAccrualSettings: `LeaveAccrual/settings`
    },
    CarryForward: {
      UpdateCarryForward: `CarryForward/UpdateCarryForward`
    },
    LeaveApproval: {
      GetApprovalStats: `LeaveApprovals/GetApprovalStats`,
      GetLeaveRequest: `LeaveApprovals/GetLeaveRequest`,
      SearchLeaveApprovals: `LeaveApprovals/Search`,
      UpdateLeaveStatus: `LeaveApprovals/UpdateLeaveStatus`,

      GetAllWithUserDetails: `LeaveApproval/with-user-details`,
      GetByLeaveId: `LeaveApproval/by-leave/`,
      GetByGroup: `LeaveApproval/by-group/`,
      GetPendingForUser: `LeaveApproval/pending-for-user/`,
      Approve: `LeaveApproval/approve`,
      Create: `LeaveApproval/create`,
      GetHistoryByLeaveId: `LeaveApproval/history/by-leave/`,
      GetHistoryByGroup: `LeaveApproval/history/by-group/`,
      GetHistoryByApprover: `LeaveApproval/history/by-approver/`,
      // Standard CRUD operations
      GetAll: `LeaveApproval`,
      GetById: `LeaveApproval/`,
      Update: `LeaveApproval/`,
      Delete: `LeaveApproval/`,
    },
    Notification: {
      GetNotifications: `Notifications/GetUserNotifications`,
      GetUnSeenCounts: `Notifications/GetUnSeenCounts`,
      UpdateToSeen: `Notifications/UpdateToSeen`,
      DeleteNotification: `Notifications/DeleteUserNotification`,
    },
    CompanyDocuments: {
      GetCompanyDocuments: "CompanyDocuments/GetCompanyDocuments",
      /** GET …/SearchCompanyDocuments — requires search; same shape as list; title, description, file name, document id */
      SearchCompanyDocuments: "CompanyDocuments/SearchCompanyDocuments",
      GetDocumentForAdminView: "CompanyDocuments/GetDocumentForAdminView",
      UploadDocument: "CompanyDocuments/UploadDocument",
      /** PUT …/UpdateCompanyDocument/{documentId} — body: CompanyDocumentUpdateRequest (documentId must match URL) */
      UpdateCompanyDocument: "CompanyDocuments/UpdateCompanyDocument",
      /** DELETE …/DeleteCompanyDocument/{documentId} */
      DeleteCompanyDocument: "CompanyDocuments/DeleteCompanyDocument",
      /** GET …/GetComplianceTracking — admin compliance summary + paginated acknowledgement rows */
      GetComplianceTracking: "CompanyDocuments/GetComplianceTracking",
      /** GET …/SearchComplianceTracking — requires search; same filters/shape as compliance list */
      SearchComplianceTracking: "CompanyDocuments/SearchComplianceTracking",
      /** GET …/ExportComplianceTracking — Excel workbook; same filters as list + optional search */
      ExportComplianceTracking: "CompanyDocuments/ExportComplianceTracking",
      /** GET …/ExportComplianceTrackingCsv — UTF-8 CSV (BOM); same filters as Excel export */
      ExportComplianceTrackingCsv: "CompanyDocuments/ExportComplianceTrackingCsv",
      /** GET …/ExportComplianceTrackingPdf — landscape PDF table; same filters as Excel export */
      ExportComplianceTrackingPdf: "CompanyDocuments/ExportComplianceTrackingPdf",
      /** GET …/GetDocumentsForAcceptance — paginated pending acknowledgements */
      GetDocumentsForAcceptance: "CompanyDocuments/GetDocumentsForAcceptance",
      /** GET …/GetPublishedCompanyDocuments — published docs + user acknowledgement status (paginated) */
      GetPublishedCompanyDocuments: "CompanyDocuments/GetPublishedCompanyDocuments",
    },
    CompanyDocumentAcknowledgements: {
      /** POST …/Respond — body: { documentId, status, comment } (CompanyDocumentResponseRequest) */
      Respond: "CompanyDocumentAcknowledgements/Respond",
    },
    Countries: {
      GetCountries: 'Countries/GetCountries'
    },
    PublicHolidays: {
      GetOfficesWithCountries: 'PublicHolidays/GetOfficesWithCountries',
      GetPublicHolidaysByCountryId: 'PublicHolidays/GetPublicHolidaysByCountryId',
      AddPublicHolidayWithLeaves: 'PublicHolidays/AddPublicHolidayWithLeaves',
      DeletePublicHolidayWithLeaves: 'PublicHolidays/DeletePublicHolidayWithLeaves'
    },
    S3Upload: {
      GetSignedUrl: 'S3Upload/GetPresignedUrl?fileName=',
      GetUploadPreSignedUrl: 'S3Upload/GetUploadPreSignedUrl',
      // Used for document/PDF/DOCX uploads (pre-signed URL)
      GetDocumentUploadPreSignedUrl: 'S3Upload/GetDocumentUploadPreSignedUrl',
    },
    Reporting: {
      AvailableYears: 'Reporting/AvailableYears',
      AnnualReport: 'Reporting/AnnualReport',
      EmployeeDemographics: 'Reporting/EmployeeDemographics',
      EmployeeTurnover: 'Reporting/EmployeeTurnover',
      SalaryCompensation: 'Reporting/SalaryCompensation',
      LeaveUtilization: 'Reporting/LeaveUtilization',
      EmployeeDevelopment: 'Reporting/EmployeeDevelopment',
      EmployeeExperience: 'Reporting/EmployeeExperience',
      DisciplinaryActions: 'Reporting/DisciplinaryActions',
      DepartmentDistribution: 'Reporting/DepartmentDistribution',
      EmploymentStatus: 'Reporting/EmploymentStatus',
      CustomDateRange: 'Reporting/CustomDateRange',
    },
    Payment: {
      Subscription: 'Payment/Subscription',
      CurrentMonthBilling: 'Payment/CurrentMonthBilling',
      CalculateBilling: 'Payment/CalculateBilling',
      PaymentHistory: 'Payment/PaymentHistory',
      CheckoutUrl: 'Payment/CheckoutUrl',
      UpdateSubscriptionPrice: 'Payment/UpdateSubscriptionPrice',
      SendPaymentMethodUpdateLink: 'Payment/SendPaymentMethodUpdateLink',
      CancelSubscription: 'Payment/CancelSubscription',
      RenewSubscription: 'Payment/RenewSubscription',
    },
    SuperAdmin: {
      Dashboard: "SuperAdmin/Dashboard",
      Companies: "SuperAdmin/Companies",
      Users: "SuperAdmin/Users",
      Payments: "SuperAdmin/Payments",
      Tickets: "SuperAdmin/Tickets",
      TicketById: "SuperAdmin/Tickets",
      TicketComments: "SuperAdmin/Tickets/comments",
      TicketUpdate: "SuperAdmin/Tickets/update",
    },
    /** Check-in/out, today activity, self edit, reports (AttendanceController) */
    Attendance: {
      Clock: `Attendance/Clock`,
      Today: `Attendance/Today`,
      Day: `Attendance/Day`,
      /** Fallback if route template uses action name instead of [HttpGet("Day")] */
      GetDayActivity: `Attendance/GetDayActivity`,
      SelfEdit: `Attendance/SelfEdit`,
      SelfDelete: `Attendance/SelfDelete`,
      SubmitChangeRequest: `Attendance/SubmitChangeRequest`,
      Report: `Attendance/Report`,
      Stats: `Attendance/Stats`,
      ExportReport: `Attendance/ExportReport`,
      ReportingStats: `Attendance/Reporting/Stats`,
      ReportingToday: `Attendance/Reporting/Today`,
      ReportingRange: `Attendance/Reporting/Range`,
      ReportingExport: `Attendance/Reporting/Export`,
    },
    /** Per-office rules — company admin */
    OfficeAttendanceSettings: {
      ByCompany: `OfficeAttendanceSettings/ByCompany`,
      ByOffice: `OfficeAttendanceSettings/ByOffice`,
      Save: `OfficeAttendanceSettings/Save`,
    },
    /** Desktop agent bind / revoke (AttendanceAgentController) — company admin */
    AttendanceAgent: {
      Bind: `AttendanceAgent/Bind`,
      Exchange: `AttendanceAgent/Exchange`,
      Token: `AttendanceAgent/Token`,
      Installations: `AttendanceAgent/Installations`,
      /** Append encodeURIComponent(installationId) */
      RevokeBase: `AttendanceAgent/Revoke/`,
    },
    /** Device mappings + unmapped punches (AttendanceDeviceAdminController) — company admin */
    AttendanceDeviceAdmin: {
      Devices: `AttendanceDeviceAdmin/Devices`,
      Mappings: `AttendanceDeviceAdmin/Mappings`,
      /** DELETE append encodeURIComponent(id) */
      MappingByIdBase: `AttendanceDeviceAdmin/Mappings/`,
      MappingRoster: `AttendanceDeviceAdmin/MappingRoster`,
      MappingEnrollment: `AttendanceDeviceAdmin/Mappings/Enrollment`,
      EnrollOptions: `AttendanceDeviceAdmin/EnrollOptions`,
      UnmappedPunches: `AttendanceDeviceAdmin/UnmappedPunches`,
      MappedPunches: `AttendanceDeviceAdmin/MappedPunches`,
      ReprocessUnmapped: `AttendanceDeviceAdmin/ReprocessUnmapped`,
    },
    /** Salary components — company-scoped earnings/deductions (SalaryComponentController) */
    SalaryComponent: {
      Offices: `SalaryComponent/offices`,
      /** GET list — same controller; adjust if backend uses a named action */
      Get: `SalaryComponent`,
      Post: `SalaryComponent`,
      Put: `SalaryComponent`,
      /** PUT `.../SalaryComponent/{id}/toggle-active` — append `encodeURIComponent(id) + '/toggle-active'`. */
      ToggleActiveBase: `SalaryComponent/`,
    },
    PayrollStructure: {
      Get: `PayrollStructure`,
      Save: `PayrollStructure/save`,
      DetailBase: `PayrollStructure/detail/`,
      PublishBase: `PayrollStructure/publish/`,
      Archive: `PayrollStructure/Archive`,
    },
    /** User salary assignment — UserSalaryAssignmentController */
    UserSalaryAssignment: {
      /** GET — company admin; all active company users + optional current assignment */
      CompanyGrid: `UserSalaryAssignment/company/users-grid`,
      /** GET — company admin; active rows from PayrollStructures (dropdown) */
      CompanyPayrollStructures: `UserSalaryAssignment/company/payroll-structures`,
      Create: `UserSalaryAssignment/create`,
      Patch: `UserSalaryAssignment/patch`,
    },
    /**
     * Tax policies (TaxPolicyController / route segment `TaxPolicy`).
     * If 404 persists, align with backend [Route] — e.g. `TaxPolicies` instead of `TaxPolicy`.
     */
    TaxPolicy: {
      /** GET supports query: page,take,policyType,scope,officeId */
      Get: `TaxPolicy/GetTaxPolicies`,
      DetailBase: `TaxPolicy/`,
      Save: `TaxPolicy/save`,
      /** PUT `.../TaxPolicy/{id}/toggle-active` — append `encodeURIComponent(id) + '/toggle-active'`. */
      ToggleActiveBase: `TaxPolicy/`,
    },
    BonusPolicy: {
      Get: `BonusPolicy`,
      DetailBase: `BonusPolicy/`,
      Save: `BonusPolicy/save`,
      PreviewEligible: `BonusPolicy/preview-eligible`,
      ExportExcel: `BonusPolicy/ExportExcel`,
      ExportCsv: `BonusPolicy/ExportCsv`,
      ExportPdf: `BonusPolicy/ExportPdf`,
    },
    BonusGeneration: {
      PrepareBase: `BonusGeneration/prepare/`,
      Post: `BonusGeneration`,
      DetailBase: `BonusGeneration/`,
    },
    /** Payslip layout template — PayslipTemplateController (optional; falls back to localStorage) */
    PayslipTemplate: {
      Get: `PayslipTemplate`,
      Save: `PayslipTemplate/save`,
      Finalize: `PayslipTemplate/finalize`,
    },
    /** Admin payroll statistics — AdminPayrollStatisticsController */
    AdminPayrollStatistics: {
      Dashboard: `AdminPayrollStatistics/Dashboard`,
      CostSummary: `AdminPayrollStatistics/CostSummary`,
      Structures: `AdminPayrollStatistics/Structures`,
      Trends: `AdminPayrollStatistics/Trends`,
      Graphs: `AdminPayrollStatistics/Graphs`,
    },
    /** Salary increments — SalaryIncrementController */
    SalaryIncrement: {
      Get: `SalaryIncrement/paged`,
      Post: `SalaryIncrement/create`,
      Put: `SalaryIncrement/update`,
      UpdateStatus: `SalaryIncrement/status`,
      EmployeesGrid: `SalaryIncrement/company/employees-grid`,
      ExportExcel: `SalaryIncrement/Export/Excel`,
      ExportCsv: `SalaryIncrement/Export/Csv`,
      ExportPdf: `SalaryIncrement/Export/Pdf`,
    },
    /** Manager / admin approval queue */
    AttendanceChangeRequests: {
      GetApproverQueuePaged: `AttendanceChangeRequests/GetApproverQueuePaged`,
      /** Current user's submissions — same filters/response shape as GetApproverQueuePaged */
      MySubmissions: `AttendanceChangeRequests/MySubmissions`,
      Stats: `AttendanceChangeRequests/Stats`,
      /** GET — append `userAttendanceEventId` → `AttendanceChangeRequests/ByEvent/{id}`; optional query `includeAllHistory=true` for every row (newest first); default is latest only */
      ByEvent: `AttendanceChangeRequests/ByEvent/`,
      Approve: `AttendanceChangeRequests/Approve`,
      Reject: `AttendanceChangeRequests/Reject`,
      Withdraw: `AttendanceChangeRequests/Withdraw`,
      ExportApproverQueueExcel: `AttendanceChangeRequests/ExportApproverQueue/Excel`,
      ExportApproverQueueCsv: `AttendanceChangeRequests/ExportApproverQueue/Csv`,
      ExportApproverQueuePdf: `AttendanceChangeRequests/ExportApproverQueue/Pdf`,
    },
    AppraisalAdmin: {
      Settings: `AppraisalAdmin/settings`,
      Schedule: `AppraisalAdmin/schedule`,
      Periods: `AppraisalAdmin/periods`,
      Values: `AppraisalAdmin/values`,
      BehaviorGroups: `AppraisalAdmin/behavior-groups`,
      Behaviours: `AppraisalAdmin/behaviours`,
      DeactivateValue: (id) => `AppraisalAdmin/values/${encodeURIComponent(id)}/deactivate`,
      DeactivateBehaviorGroup: (id) => `AppraisalAdmin/behavior-groups/${encodeURIComponent(id)}/deactivate`,
      DeactivateBehaviour: (id) => `AppraisalAdmin/behaviours/${encodeURIComponent(id)}/deactivate`,
      RatingScale: `AppraisalAdmin/rating-scale`,
      Compliance: `AppraisalAdmin/compliance`,
      Dashboard: `AppraisalAdmin/dashboard`,
      Offices: `AppraisalAdmin/offices`,
      StartCycle: `AppraisalAdmin/start-cycle`,
      StopCycle: `AppraisalAdmin/stop-cycle`,
    },
    UserAppraisal: {
      MineCurrent: `UserAppraisal/mine/current`,
      MineHistory: `UserAppraisal/mine/history`,
      Team: `UserAppraisal/team`,
      TeamCycles: `UserAppraisal/team-cycles`,
      TeamDashboard: `UserAppraisal/team-dashboard`,
      Features: `UserAppraisal/features`,
      DetailBase: `UserAppraisal/`,
      Reviews: `UserAppraisal/reviews`,
      RetroReviews: `UserAppraisal/retro-reviews`,
      SubmitSelf: `UserAppraisal/submit-self`,
      SubmitManager: `UserAppraisal/submit-manager`,
      SubmitMeeting: `UserAppraisal/submit-meeting`,
      RecommendPayIncrease: `UserAppraisal/recommend-pay-increase`,
    },
    AppraisalGoals: {
      Objectives: `AppraisalGoals/objectives`,
      ObjectiveGroups: `AppraisalGoals/objective-groups`,
      Mine: `AppraisalGoals/mine`,
      Team: `AppraisalGoals/team`,
      DetailBase: `AppraisalGoals/`,
      Save: `AppraisalGoals/save`,
      SubmitApproval: `AppraisalGoals/submit-approval`,
      Approve: `AppraisalGoals/approve`,
      RateUser: `AppraisalGoals/rate-user`,
      AgreeManager: `AppraisalGoals/agree-manager`,
      DiscussManager: `AppraisalGoals/discuss-manager`,
      Complete: `AppraisalGoals/complete`,
      Comments: `AppraisalGoals/comments`,
    },
    AppraisalRetrospective: {
      List: `AppraisalRetrospective`,
      Groups: `AppraisalRetrospective/groups`,
      Deactivate: (id) => `AppraisalRetrospective/${encodeURIComponent(id)}/deactivate`,
      DeactivateGroup: (id) => `AppraisalRetrospective/groups/${encodeURIComponent(id)}/deactivate`,
    },
    AppraisalEvidence: {
      Mine: `AppraisalEvidence/mine`,
      List: `AppraisalEvidence`,
      DetailBase: `AppraisalEvidence/`,
    },
    AppraisalPdp: {
      Mine: `AppraisalPdp/mine`,
      Team: `AppraisalPdp/team`,
      DetailBase: `AppraisalPdp/`,
      Save: `AppraisalPdp/save`,
      SubmitApproval: `AppraisalPdp/submit-approval`,
      Approve: `AppraisalPdp/approve`,
      Complete: `AppraisalPdp/complete`,
      Comments: `AppraisalPdp/comments`,
    },
    AppraisalOneToOne: {
      Mine: `AppraisalOneToOne/mine`,
      Team: `AppraisalOneToOne/team`,
      DetailBase: `AppraisalOneToOne/`,
      Save: `AppraisalOneToOne/save`,
      Complete: `AppraisalOneToOne/complete`,
      Comments: `AppraisalOneToOne/comments`,
      ConversationsMine: `AppraisalOneToOne/conversations/mine`,
      ConversationsTeam: `AppraisalOneToOne/conversations/team`,
      ConversationsDetailBase: `AppraisalOneToOne/conversations/`,
      ConversationsSave: `AppraisalOneToOne/conversations/save`,
      ConversationsComplete: `AppraisalOneToOne/conversations/complete`,
      ConversationsComments: `AppraisalOneToOne/conversations/comments`,
    },
    AppraisalLms: {
      Active: `AppraisalLms/active`,
      List: `AppraisalLms`,
      DetailBase: `AppraisalLms/`,
    },
    Ticket: {
      Mine: `Ticket/mine`,
      Company: `Ticket/company`,
      DetailBase: `Ticket/`,
      Create: `Ticket/create`,
      Comments: `Ticket/comments`,
      Update: `Ticket/update`,
    },
  },
};
